// extracted by mini-css-extract-plugin
export default {"ordersPerAreaChart__noData":"ordersPerAreaChart_ordersPerAreaChart__noData__6E4rO","ordersPerAreaChart__noDataText":"ordersPerAreaChart_ordersPerAreaChart__noDataText__C7JZM"};